import { lazy, Suspense } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import LazyLoading from '../../components/LazyLoading';

const LazyGiftPotPage = lazy(
  () => import(/* webpackChunkName: 'GiftPotPage' */ './Page'),
);

export default function GiftPotPage({
  match,
}: RouteComponentProps<{ slug: string }>) {
  return (
    <Suspense fallback={<LazyLoading />}>
      <LazyGiftPotPage key={match.params.slug} slug={match.params.slug} />
    </Suspense>
  );
}
